import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { BRAND_ASSETS } from '../../config/assets';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './HomePage.css';

export default function HomePage() {
      const heroRef = useRef(null);
      const { pathFor, t } = useLanguage();

      const features = [
            {
                  title: t('features.registration.title'),
                  desc: t('features.registration.desc'),
            },
            {
                  title: t('features.search.title'),
                  desc: t('features.search.desc'),
            },
            {
                  title: t('features.assistant.title'),
                  desc: t('features.assistant.desc'),
            },
            {
                  title: t('features.deals.title'),
                  desc: t('features.deals.desc'),
            },
            {
                  title: t('features.delivery.title'),
                  desc: t('features.delivery.desc'),
            },
      ];

      const roadmap = [
            {
                  title: t('roadmap.deliveryAndPayments.title'),
                  desc: t('roadmap.deliveryAndPayments.desc'),
                  status: 'completed',
            },
            {
                  title: t('roadmap.aiModeration.title'),
                  desc: t('roadmap.aiModeration.desc'),
                  status: 'completed',
            },
            {
                  title: t('roadmap.mobileApp.title'),
                  desc: t('roadmap.mobileApp.desc'),
                  status: 'completed',
            },
            {
                  title: t('roadmap.clientsAndInvestors.title'),
                  desc: t('roadmap.clientsAndInvestors.desc'),
                  status: 'in_progress',
            },
      ];

      useEffect(() => {
            const observer = new IntersectionObserver(
                  (entries) => {
                        entries.forEach((entry) => {
                              if (entry.isIntersecting) {
                                    entry.target.classList.add('visible');
                              }
                        });
                  },
                  { threshold: 0.1 }
            );
            document.querySelectorAll('.animate-on-scroll').forEach((el) => observer.observe(el));
            return () => observer.disconnect();
      }, []);

      return (
            <div className="home">
                  <Navbar />

                  {/* Hero */}
                  <section className="hero" ref={heroRef}>
                        <div className="hero__bg">
                              <div
                                    className="hero__photo"
                                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/hero-agriculture.jpg)` }}
                              />
                              <div className="hero__grid" />
                        </div>
                        <div className="hero__inner">
                              <h1 className="hero__title animate-on-scroll">
                                    {t('hero.title')}{' '}
                                    <span className="hero__title-accent">{t('hero.titleAccent')}</span>
                              </h1>
                              <p className="hero__subtitle animate-on-scroll">
                                    {t('hero.subtitle')}
                              </p>
                              <div className="hero__cta animate-on-scroll">
                                    <a href="#features" className="btn btn--primary" id="hero-get-started">
                                          {t('hero.getStarted')}
                                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    </a>
                                    <Link to={pathFor('support')} className="btn btn--ghost" id="hero-contact">
                                          {t('hero.contact')}
                                    </Link>
                              </div>
                              <div className="hero__store-badges animate-on-scroll">
                                    {/* App Store Badge */}
                                    <a
                                          href="https://apps.apple.com/app/id6802196676"
                                          className="store-badge store-badge--active"
                                          id="hero-app-store"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                    >
                                          <div className="store-badge__btn">
                                                <svg className="store-badge__icon" viewBox="0 0 24 24" fill="currentColor">
                                                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.32c.67-.82 1.12-1.95.99-3.09-1 .04-2.18.67-2.88 1.48-.63.73-1.18 1.89-1.03 3.02 1.11.09 2.25-.59 2.92-1.41z" />
                                                </svg>
                                                <div className="store-badge__content">
                                                      <span className="store-badge__title">App Store</span>
                                                </div>
                                          </div>
                                    </a>

                                    {/* Google Play Badge */}
                                    <a
                                          href="https://play.google.com/store/apps/details?id=com.agrollama"
                                          className="store-badge store-badge--active"
                                          id="hero-google-play"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                    >
                                          <div className="store-badge__btn">
                                                <svg className="store-badge__icon" viewBox="0 0 512 512" fill="currentColor">
                                                      <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l220.7-221.3 60.1 60.1L104.6 499z" />
                                                </svg>
                                                <div className="store-badge__content">
                                                      <span className="store-badge__title">Google Play</span>
                                                </div>
                                          </div>
                                    </a>
                              </div>
                        </div>
                  </section>

                  {/* Roadmap */}
                  <section className="roadmap">
                        <div className="roadmap__inner">
                              <div className="section-header animate-on-scroll">
                                    <span className="section-tag">{t('roadmap.tag')}</span>
                                    <h2 className="section-title">{t('roadmap.title')}</h2>
                              </div>
                              <div className="roadmap__grid">
                                    {roadmap.map((item, i) => (
                                          <div className={`roadmap__item roadmap__item--${item.status} animate-on-scroll`} key={i}>
                                                <div className="roadmap__dot" />
                                                <span className={`roadmap__status roadmap__status--${item.status}`}>
                                                      {item.status === 'completed' ? t('roadmap.status.completed') : t('roadmap.status.inProgress')}
                                                </span>
                                                <h3 className="roadmap__item-title">{item.title}</h3>
                                                <p className="roadmap__item-desc">{item.desc}</p>
                                          </div>
                                    ))}
                              </div>
                        </div>
                  </section>

                  {/* Mascot Showcase Section */}
                  <section className="mascot-section">
                        <div className="mascot-section__inner animate-on-scroll">
                              <div className="mascot-section__image-wrap">
                                    <img src={BRAND_ASSETS.mascot} alt="AgroLlama Mascot" className="mascot-section__img" />
                              </div>
                              <div className="mascot-section__content">
                                    <span className="section-tag">{t('mascot.tag')}</span>
                                    <h2 className="mascot-section__title">{t('mascot.title')}</h2>
                                    <p className="mascot-section__desc">{t('mascot.desc')}</p>
                              </div>
                        </div>
                  </section>

                  {/* Features */}
                  <section className="features" id="features">
                        <div className="features__inner">
                              <div className="section-header animate-on-scroll">
                                    <span className="section-tag">{t('features.tag')}</span>
                                    <h2 className="section-title">{t('features.title')}</h2>
                                    <p className="section-desc">
                                          {t('features.desc')}
                                    </p>
                              </div>
                              <div className="features__grid">
                                    {features.map((f, i) => (
                                          <div className="feature-card animate-on-scroll" key={i} id={`feature-${i}`}>
                                                <h3 className="feature-card__title">{f.title}</h3>
                                                <p className="feature-card__desc">{f.desc}</p>
                                          </div>
                                    ))}
                              </div>
                        </div>
                  </section>

                  {/* CTA Band */}
                  <section className="cta-band">
                        <div className="cta-band__inner animate-on-scroll">
                              <h2 className="cta-band__title">{t('cta.title')}</h2>
                              <p className="cta-band__desc">{t('cta.desc')}</p>
                              <Link to={pathFor('support')} className="btn btn--primary btn--lg" id="cta-contact">
                                    {t('cta.button')}
                              </Link>
                        </div>
                  </section>

                  <Footer />
            </div>
      );
}
